// Aviron brand mark (the rowing "A" glyph from the official AVIRON wordmark,
// https://www.avironactive.com/assets/icon/aviron-logo.svg — mark only, cropped
// to its 0..35.6 x-extent). Paths use `fill="currentColor"` so callers set the
// color via `color` (e.g. white inside the orange brand tile). The full
// wordmark lives at src/assets/aviron-logo.svg.

interface AvironIconProps {
  size?: number;
  /** CSS color for the mark; defaults to currentColor. */
  color?: string;
  title?: string;
}

export function AvironIcon({ size = 20, color = 'currentColor', title = 'Aviron' }: AvironIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35.6 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path
        d="M35.2712 17.499C35.2712 21.5234 33.906 25.2362 31.6119 28.1952C31.2201 28.7027 30.8016 29.1865 30.3564 29.6465C29.0773 30.9731 27.5874 32.0979 25.9462 32.9675C25.4417 33.2346 24.9193 33.481 24.3851 33.6976C22.3432 34.5346 20.1084 34.9976 17.7668 34.9976C15.5052 34.9976 13.3417 34.5672 11.3532 33.7807C11.2404 33.7362 11.187 33.6056 11.2375 33.4928L12.7095 30.157L12.7125 30.1451L12.7184 30.1332L13.0775 29.2844C13.1221 29.1776 13.2437 29.1271 13.3506 29.1687C14.7247 29.688 16.2116 29.9759 17.7638 29.9759C19.3902 29.9759 20.9424 29.6643 22.367 29.0974C22.9041 28.8837 23.4235 28.6315 23.9221 28.3495C25.6138 27.3879 27.0562 26.0435 28.1365 24.4319C28.5401 23.8265 28.8963 23.1854 29.193 22.5117C29.8697 20.9774 30.2437 19.2827 30.2437 17.499C30.2437 12.1747 26.89 7.61602 22.18 5.82639C22.1266 5.80562 22.082 5.76407 22.0583 5.71065L19.8235 0.442686C19.7582 0.288357 19.8858 0.125124 20.052 0.1459C28.6321 1.27072 35.2712 8.62509 35.2712 17.499Z"
        fill={color}
      />
      <path
        d="M19.9868 5.21751L17.7728 0L18.1022 0.777582L20.5181 6.46995L20.8089 7.15256H20.8119L19.9868 5.21751ZM11.1396 29.459L11.1218 29.5036L11.1396 29.465L11.1604 29.4175L11.1396 29.459Z"
        fill={color}
      />
      <path
        d="M31.203 31.637C31.1437 31.5005 30.9686 31.4649 30.8587 31.5658C29.6241 32.7173 28.247 33.6967 26.7572 34.4892C26.7215 34.5099 26.683 34.5277 26.6473 34.5456L26.7898 34.869C26.8254 34.9462 26.8996 34.9967 26.9857 34.9967H32.3071C32.4614 34.9967 32.5653 34.8394 32.5029 34.6999L31.203 31.637Z"
        fill={color}
      />
      <path
        d="M27.2707 22.3718C27.2974 22.4312 27.2944 22.4994 27.2617 22.5588C27.0926 22.8734 26.9115 23.1791 26.7127 23.4729C25.8639 24.7372 24.748 25.8175 23.4629 26.6218C23.3531 26.69 23.2047 26.6426 23.1542 26.5209L21.9077 23.5827L18.6995 16.0413C18.3522 15.2222 17.1888 15.2222 16.8416 16.0413L13.6303 23.5827L12.2354 26.874L11.6122 28.3491L11.1581 29.4175L11.1373 29.465L11.1195 29.5036L9.59107 32.97L9.34474 33.528L8.75117 34.8724C8.71555 34.9496 8.64135 35.0001 8.55529 35.0001H3.23687C3.08254 35.0001 2.97867 34.8428 3.04099 34.7033L5.18676 29.649L7.40079 24.4315L15.3992 5.59148C15.4674 5.43122 15.325 5.26205 15.1558 5.29766C14.5682 5.42231 13.9954 5.59148 13.4404 5.79626C8.68884 7.56214 5.2936 12.1416 5.2936 17.5015C5.2936 19.2526 5.65568 20.9175 6.30861 22.4312C6.33235 22.4846 6.33235 22.5439 6.30861 22.5973L4.07678 27.8594C4.01148 28.0137 3.8067 28.0345 3.70579 27.9009C1.54816 24.9924 0.271973 21.3924 0.271973 17.5015C0.271973 8.49999 7.104 1.06252 15.8562 0.106866C16.4854 0.0386047 17.1235 0.00299072 17.7705 0.00299072L19.9845 5.2205L20.8066 7.15555L27.2707 22.3718Z"
        fill={color}
      />
    </svg>
  );
}

export default AvironIcon;
